import ChangeColumn from './ChangeColumn';

export default ChangeColumn;
